module.exports = __webpack_public_path__ + "img/logo.da40437e.png";